import React from 'react';
import { Modal, Platform } from 'react-native';
import CS from '../constants/Styles';
import { Portal } from 'react-native-paper';
import Loader from '../components/Loader';

const IFrameModal = (props) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if(Platform.OS === 'web'){
      window.addEventListener("message", (event) => {
        if (event.origin === "https://dev.renovationtrust.com" || event.origin === "https://www.renovationtrust.com") {
          console.log('message: ', event);
          if (props.onMessage && typeof props.onMessage === 'function') {
            if (event.data.close){
              props.set(false);
            }
            if(event.data.loading !== undefined){
              console.log('setLoading iframemodal message event: ', event.data.loading);
              setLoading(event.data.loading);
            }
            props.onMessage(event);
          }
        }
      }, false);
    }
  }, []);

  React.useEffect(() => {
    console.log('useEffect props.show: ', props.show);
    if(props.show){
      console.log('setLoading true');
      setLoading(true);
    }
  }, [props?.show])

  React.useEffect(() => {
    console.log('useEffect props.source: ', props.source);
  }, [props?.source])

  if (Platform.OS === 'web' && !props.show) {
    return null;
  }

  return (
    <Portal>
      <Modal
        animationType="fade"
        transparent={true}
        visible={props.show}
        style={Platform.OS === 'web' && CS.webModal}
      >
        <Loader animating={loading} />
        <iframe
          src={props.source}
          frameborder='0'
          width={props.size ? props.size.width : '100%'}
          height={props.size ? props.size.height : '100%'}
        />
      </Modal>
    </Portal>
  );
}

export default IFrameModal;